import { useEffect, useRef } from "react";
import L from "leaflet";

// Fix default marker icons
const blueIcon = L.divIcon({
  className: "",
  html: `<div style="position:relative"><div style="width:22px;height:22px;background:#0EA5E9;border:3px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 0 12px rgba(14,165,233,0.8)"></div></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 22],
});

const LocationMap = ({ lat, lng, onChange, interactive = true, height = "320px" }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const startLat = lat ?? 51.2194;
    const startLng = lng ?? 4.4025;
    const map = L.map(containerRef.current, { zoomControl: interactive, dragging: interactive, scrollWheelZoom: interactive }).setView([startLat, startLng], lat ? 15 : 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; OpenStreetMap',
      maxZoom: 19,
    }).addTo(map);

    const marker = L.marker([startLat, startLng], { draggable: interactive, icon: blueIcon }).addTo(map);
    markerRef.current = marker;
    mapRef.current = map;

    if (interactive) {
      map.on("click", (e) => {
        marker.setLatLng(e.latlng);
        onChange && onChange(e.latlng.lat, e.latlng.lng);
      });
      marker.on("dragend", () => {
        const p = marker.getLatLng();
        onChange && onChange(p.lat, p.lng);
      });
    }

    setTimeout(() => map.invalidateSize(), 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mapRef.current && markerRef.current && lat != null && lng != null) {
      markerRef.current.setLatLng([lat, lng]);
      mapRef.current.setView([lat, lng], 15);
    }
  }, [lat, lng]);

  return <div ref={containerRef} data-testid="location-map" style={{ height, width: "100%" }} className="rounded-xl overflow-hidden border border-slate-700/60 z-0" />;
};

export default LocationMap;
